import { jsx } from "react/jsx-runtime";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import { validateTidalLicense } from "../../base/index.js";
function ReplyAll(props) {
  return /* @__PURE__ */ jsx(
    ReplyAllIcon,
    {
      "data-testid": "ReplyAll",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ReplyAll",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
ReplyAll.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "ReplyAll"
};
validateTidalLicense();
export {
  ReplyAll
};
//# sourceMappingURL=ReplyAll.js.map
